import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { LogOut } from "iconoir-react";
import { useQuery } from "@tanstack/react-query";
import { Avatar } from "@/components/ui/avatar";
import { Icon } from "@/design-system/icons/icon";
import {
  avatarQuery,
  overviewQuery,
  useAvatarImageErrorRecovery,
} from "@/features/account/queries";
import { useAuth } from "@/features/auth/auth-context";
import { m } from "@/i18n/en";

function initials(value: string) {
  return (
    value
      .split(/\s+|@/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase())
      .join("") || "SC"
  );
}

export function AccountMenu() {
  const { data } = useQuery(overviewQuery);
  const { data: avatar } = useQuery(avatarQuery);
  const recoverAvatarImage = useAvatarImageErrorRecovery();
  const { logout } = useAuth();
  const label = data?.display_name || data?.email || m.account;
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        className="grid size-11 place-items-center rounded-full"
        aria-label={m.menu.account}
      >
        <Avatar
          fallback={initials(label)}
          onImageError={recoverAvatarImage}
          size={36}
          src={avatar?.url}
          version={avatar?.version}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          className="z-[70] w-72 rounded-[var(--radius-lg)] border border-line bg-elevated p-2 shadow-xl"
          sideOffset={8}
        >
          <div className="px-3 py-3">
            <p className="truncate font-semibold">{label}</p>
            {data?.email && (
              <p className="mt-1 truncate text-sm text-secondary">
                {data.email}
              </p>
            )}
          </div>
          <DropdownMenu.Separator className="my-1 h-px bg-line" />
          <DropdownMenu.Item
            className="flex min-h-11 cursor-default items-center gap-3 rounded-[var(--radius-md)] px-3 text-sm text-danger outline-none data-[highlighted]:bg-hover"
            onSelect={() => void logout()}
          >
            <Icon glyph={LogOut} /> {m.menu.signOut}
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
